import gql from "graphql-tag";

export const getAllProductosGql = gql`
    query data {
        productos{
            codigo
            denominacion
        }
    }
`;